<template>
  <a-layout-content class="wemail-sites-overview">
    <a-breadcrumb :style="{ marginBottom: '20px' }">
      <a-breadcrumb-item>
        <router-link tag="a" :to="{ name: 'sites.overview', params: { siteId: this.$route.params.siteId } }">Site</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>Site Subscription</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="wemail-tabs-wrap">
      <SitesNavigation/>
      <div class="wemail-overview-content">
        <a-card title="Site subscription">
          <span> <b> Current Plan: </b> {{ data.plan ? data.plan.name : '' }} <span v-if="tierType()"> - subscribers up to {{ data.tier.max_quantity ? data.tier.max_quantity : 'Unlimited'}}</span> </span>
          <p v-if="tierType()"> <b> Subscription End Date: </b> {{ data.site.subscription_ends_at }} </p>
          <p v-else>
            <b> Subscription for lifetime</b>
            <a-divider />
            <a-form-item label="Subscription details">
              <a-row>
                <a-col :span="12">
                  <a-select defaultValue="Edit ltd package" @change="selectLtdPackage">
                    <a-select-option v-for="option in plans" :key="option.id" :value="option.gateway_id">{{ option.name }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="12">
                  <a-input
                      v-model="subscriberCount"
                      v-if="editSubscriber && !selectLtd"
                      v-decorator="[
                        'email',
                        {
                          initialValue: subscriberCount,
                          rules: [
                            { type: 'number', message: 'The input is not valid' },
                            { required: true, message: 'This field cannot be empty' }
                          ],
                        },
                      ]"/>
                  <span v-else style="padding-right: 10px; margin-left: 20px">{{ subscriberCount }}</span>
                  <a-button v-if="!selectLtd" type="primary" size="small" :icon="editSubscriber ? '' : 'edit'" @click.prevent="editSubscriber = !editSubscriber">
                    {{ editSubscriber ? 'Cancel' : 'Edit' }}
                  </a-button>
                  <a-button v-if="editSubscriber || selectLtd" type="primary" size="small" html-type="submit" style="margin-left: 20px" @click.prevent="subscriptionUpgrade()">
                    Update
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </p>
        </a-card>
      </div>
    </div>
  </a-layout-content>
</template>

<script>
import SitesNavigation from "@/components/SitesNavigation.vue";
import Api from "@/services/Api";

export default {
  components: {SitesNavigation},

  data() {
    return {
      data: '',
      editSubscriber: false,
      selectLtd: false,
      plans: '',
      subscriberCount: 0,
      updatedLtd: ''
    }
  },

  methods: {
    loadInitData() {
      Api.get(`sites/${this.$route.params.siteId}/subscription-info`).then(res => {
        this.data = res.data;
        this.subscriberCount = res.data.tier ? res.data.plan.no_of_subscribers : res.data.ltdSubscription.quantity;
      });

      Api.get(`ltd-subscription`).then(res => {
        this.plans = res.data.plan;
      })
    },
    tierType() {
      if (this.data) {
        return this.data.tier !== null;
      }
    },
    selectLtdPackage(evt) {
      this.editSubscriber = true;
      this.selectLtd = true;
      this.updatedLtd = evt;
      this.subscriberCount = this.plans.find(plan => plan.gateway_id === evt).no_of_subscribers;
    },
    subscriptionUpgrade() {
      Api.post(`sites/${this.$route.params.siteId}/subscription-upgrade`, {'stripe': this.updatedLtd, 'subscriber': this.subscriberCount}).then(() => {
        window.location.reload();
      })
    }
  },
  mounted() {
    this.loadInitData();
  }
}
</script>